/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Happy({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#Happy_svg__a)"><path d="M5.287 9.732a.6.6 0 0 0-1.074.536C4.837 11.515 6.123 12.6 8 12.6s3.163-1.085 3.787-2.332a.6.6 0 0 0-1.074-.536C10.26 10.639 9.353 11.4 8 11.4s-2.26-.761-2.713-1.668M6 5.4a.6.6 0 0 1 .6.6v1.5a.6.6 0 1 1-1.2 0V6a.6.6 0 0 1 .6-.6M10.6 6a.6.6 0 1 0-1.2 0v1.5a.6.6 0 1 0 1.2 0z" /><path fillRule="evenodd" d="M8 .4a7.6 7.6 0 1 0 0 15.2A7.6 7.6 0 0 0 8 .4M1.6 8a6.4 6.4 0 1 1 12.8 0A6.4 6.4 0 0 1 1.6 8" clipRule="evenodd" /></g><defs><clipPath id="Happy_svg__a"><path fill="currentColor" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;